
<style lang="scss" scoped>
.field{
   font-family: 'Manrope';
   font-weight: 500;
   color: #1f1f1f;
   position: relative;
   background: #FFF;
   border: 1px solid #e0e0e0;
   box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;
   margin: 20px -30px;
   padding: 20px 30px;
   &__similarity{
      padding: 15px 25px 20px 25px;
      // background: #f5f5f5;
      background: #f2fffe;
      border-top:1px solid #dcedec;
   }
}

#sds-report{
//   background: rgb(245, 245, 245);
  min-height: calc(100vh - 63px);
}
</style>
<style>
#sds-report legend.col-form-label{
   font-size: 12px !important;
}
</style>
<template>
  <div>
    <div id="sds-report" class="content content--borderless">
      <div class="content__header">
        <div class="content__main-header">
          <div class="content__title">
            <div class="content__title__name">Report &nbsp;<span class="text-primary">SDS</span></div>
            <div class="content__title__description">Gunakan beberapa pilihan filter untuk mengenerate laporan sesuai kebutuhan Anda.</div>
          </div>
        </div>
      </div>
      <div class="content__body">
         <div class="mt-4">
            <b-row class="align-items-end">
               <b-col class="pr-1" cols="1">
                  <b-form-group label="Periode" class="mb-0">
                     <Treeselect 
                        :clearable="false" placeholder="Pilih tahun usulan SDS" 
                        v-model="submissionPeriod" :options="options.submissionPeriod"
                     />
                  </b-form-group>
               </b-col>
               <b-col class="px-1" cols="2">
                  <b-form-group label="Jenis SDS" class="mb-0">
                     <Treeselect 
                        :clearable="false" placeholder="Pilih tahun usulan SDS" 
                        v-model="sdsType" :options="options.sdsType"
                     />
                  </b-form-group>
               </b-col>
               <b-col class="px-1">
                  <b-form-group label="Status" class="mb-0">
                     <Treeselect 
                        clearable placeholder="Pilih status" 
                        v-model="status" :options="sdsStatus" :disable-branch-nodes="true" :normalizer="normalizer"
                     />
                  </b-form-group>
               </b-col>
               <b-col class="px-1" v-if="filterProdusenDataVisible">
                  <b-form-group label="Produsen Data" class="mb-0">
                     <Treeselect 
                        clearable
                        placeholder="Nama Produsen Data"
                        v-model="produsenDataId"
                        :async="filterProdusenDataDisabled == true ? false : true"
                        :options="options.produsenData"
                        :loadOptions="produsenDataLoadOptions"
                        :normalizer="produsenDataNormalizer"
                        :disabled="filterProdusenDataDisabled"
                        searchPromptText="Ketikkan beberapa huruf terlebih dahulu untuk memulai pencarian... "
                     />
                  </b-form-group>
               </b-col>
               <b-col class="px-1" v-if="filterWalidataVisible">
                  <b-form-group label="Walidata Pusat" class="mb-0">
                     <Treeselect 
                        clearable
                        placeholder="Nama Walidata Pusat"
                        v-model="walidataPusatId"
                        :async="true"
                        :options="options.walidata"
                        :loadOptions="walidataPusatLoadOptions"
                        :normalizer="produsenDataNormalizer"
                        searchPromptText="Ketikkan beberapa huruf terlebih dahulu untuk memulai pencarian... "
                     />
                  </b-form-group>
               </b-col>

               <b-col class="pl-1" cols="auto">
                  <button type="button" class="button" variant="dark"  @click="getSdsItemList">
                     <VueFeather type="play" size="13" class="button__icon"></VueFeather>
                     Generate
                  </button>
               </b-col>
            </b-row>
            <div class="table-wrapper mt-3 mb-5">
               <div class="pagination-wrapper py-2 border-top-0 px-3" style="background:#f4f4f4">
                  <div>
                     <div class="text-16">Preview Report <span class="text-primary">{{sdsType == 'CONCEPT' ? 'Konsep & Definisi Baku Statistik' : (sdsType == 'VARIABLE' ? 'Variabel' : 'Indikator') }}</span></div>
                     <div class="d-flex text-12 text-700">
                        <div class="pr-2 border-right">
                           Jumlah Item : {{table.pagination.totalElements}}
                        </div>
                        <div class="pl-2">
                           Jumlah Halaman: {{table.pagination.totalPages}}
                        </div>
                     </div>
                  </div>

                  <div class="pagination__goto ml-auto">
                     <div class="w-90 mr-2">
                        <Treeselect 
                           :clearable="false"
                           v-model="fileType"
                           :options="options.fileType"
                        />
                     </div>
                     <button type="button" class="button" variant="primary" @click="exportReport" :disabled="table.items.length==0">
                        <VueFeather type="upload" size="14" class="button__icon"></VueFeather>
                        Export
                     </button>
                  </div>
               </div>
               <!-- CONCEPT -->

               <table id="export-concepts" class="table table--light table--bordered" v-if="sdsType == 'CONCEPT'">
                  <thead>
                     <tr>
                        <th class="w-70 text-center">No. Urut</th>
                        <th class="w-80">ID SDSN</th>
                        <th class="text-left">Konsep</th>
                        <th class="text-left">Definisi</th>
                        <th class="text-left w-150">Status</th>
                     </tr>
                  </thead>
                  <tbody v-for="(item,index) in table.items" :key="index">
                     <tr >
                        <td class="text-center" :rowspan="isRejected(item.status) && item.alternative_sds_item ? 3: 0">
                           {{table.pagination.currentPage == 1 ? ( index + 1 ) : (((table.pagination.currentPage-1)*table.pagination.pageSize)+(index + 1))}}
                        </td>
                        <td class="text-center">{{item.code ? item.code : '-'}}</td>
                        <td>{{item.data.concept && item.data.concept.name ? item.data.concept.name : '-'}}</td>
                        <td>{{item.data.concept && item.data.concept.definition ? item.data.concept.definition : '-'}}</td>
                        <td class="text-left">
                           <span  style="background:none;border:none;border-radius:0" :class="'text-left p-0 status status--'+statusFormatterStyle(item.status)">
                              {{statusFormatter(item.status)}}
                           </span>
                           <span v-if="isRejected(item.status)"> 
                              : {{rejectionNoteFormatter(item.rejection_note)}} </span>
                        </td>
                       
                     </tr>
                     <tr  v-if="isRejected(item.status) && item.alternative_sds_item">
                        <td colspan="9" class="text-bold">Rekomendasi usulan pengganti :</td>
                     </tr>

                     <tr v-if="isRejected(item.status) && item.alternative_sds_item">
                        <td class="text-center"> {{item.alternative_sds_item.data.concept.code || '-'}}</td>
                        <td > {{item.alternative_sds_item.data.concept.name || '-'}}</td>
                        <td > {{item.alternative_sds_item.data.concept.definition || '-'}}</td>
                        
                        <td >
                           <span  
                              style="background:none;border:none;border-radius:0" 
                              :class="'text-left p-0 status status--'+statusFormatterStyle(item.alternative_sds_item.status)"
                           >
                              {{statusFormatter(item.alternative_sds_item.status)}}
                           </span>
                        </td>
                     </tr>
                  </tbody>
                  <tbody v-if="table.isLoading || table.items.length==0">
                     <tr>
                        <td colspan="9">
                           <div class="table__empty">
                              <div v-if="table.isLoading">
                                 <VueFeather type="loader" animation="spin" size="18"></VueFeather> &nbsp; Memuat data dari server ({{exportPercentage}}%)</div>
                              <div v-else>
                                 <VueFeather type="alert-circle" size="18"></VueFeather> &nbsp;
                                    Data tidak tersedia, silahkan generate report terlebih dahulu
                              </div>
                           </div>
                        </td>
                     </tr>
                  </tbody>
               </table>

               <table id="export-variables" class="table table--light table--bordered" v-if="sdsType == 'VARIABLE'">
                  <thead>
                     <tr>
                        <th class="w-70 text-center">No. Urut</th>
                        <th class="w-80">Kode Identitas SDSN</th>
                        <th class="text-left">Nama Data</th>
                        <th class="text-left">Definisi</th>
                        <th class="text-left">Klasifikasi Penyajian</th>
                        <th class="text-left">Klasifikasi Isian</th>
                        <th class="text-left w-120">Ukuran</th>
                        <th class="text-left w-120">Satuan</th>
                        <th class="text-left">Konsep</th>
                        <th class="text-left w-150">Status</th>
                     </tr>
                  </thead>
                  <tbody>
                     <tr v-for="(variable,index) in table.items.map(x=>x.data.variable).filter(x=>x != null)" :key="index">
                        <td class="text-center">
                           {{table.pagination.currentPage == 1 ? ( index + 1 ) : (((table.pagination.currentPage-1)*table.pagination.pageSize)+(index + 1))}}
                        </td>
                        <td class="text-center">{{table.items[index].code || '-'}}</td>
                        <td>{{variable.name || '-'}}</td>
                        <td>{{variable.definition || '-'}}</td>
                        <td>-</td>
                        <td class="w-min-26">
                           <span v-for="item in variable.value_domain.items" v-bind:key="item.code">
                           {{ item.code+". "+item.name+"; &nbsp;" }}<br/></span>
                        </td>
                        <td>{{variable.measurement ? variable.measurement.name : '-'}}</td>
                        <td>{{variable.measurement_unit ? variable.measurement_unit.name : '-'}}</td>
                        <td>
                           <span v-for="item in variable.concepts" v-bind:key="item.code">
                           {{ item.name+"; &nbsp;" }}<br/></span>
                        </td>
                        <td>
                           <span  style="background:none;border:none;border-radius:0" :class="'text-left p-0 status status--'+statusFormatterStyle(table.items[index].status)">
                              {{statusFormatter(table.items[index].status)}}
                           </span>
                           <span v-if="isRejected(table.items[index].status)"> 
                              : {{rejectionNoteFormatter(table.items[index].status.rejection_note)}} </span>
                        </td> 
                        
                     </tr>
                  </tbody>
                  
                  <tbody v-if="table.isLoading || table.items.length==0">
                     <tr>
                        <td colspan="9">
                           <div class="table__empty">
                              <div v-if="table.isLoading">
                                 <VueFeather type="loader" animation="spin" size="18"></VueFeather> &nbsp; Memuat data dari server ({{exportPercentage}}%)</div>
                              <div v-else>
                                 <VueFeather type="alert-circle" size="18"></VueFeather> &nbsp;
                                    Data tidak tersedia, silahkan generate report terlebih dahulu
                              </div>
                           </div>
                        </td>
                     </tr>
                  </tbody>
               </table>

               <table id="export-indicators" class="table table--light  table--bordered" v-if="sdsType == 'INDICATOR'">
                  <thead>
                     <tr>
                        <th class="w-70 text-center">No. Urut</th>
                        <!-- <th class="w-80">Jenis SDS</th> -->
                        <th class="w-80">Kode Identitas SDSN</th>
                        <th class="text-left">Nama Data</th>
                        <th class="text-left">Definisi</th>
                        <th class="text-left">Klasifikasi Penyajian</th>
                        <th class="text-left">Klasifikasi Isian</th>
                        <th class="text-left w-120">Ukuran</th>
                        <th class="text-left w-120">Satuan</th>
                        <th class="text-left">Konsep</th>
                        <th class="text-left w-150">Status</th>
                     </tr>
                  </thead>
                  <tbody v-for="(item,index) in table.items" :key="index">
                     <tr>
                        <td  class="text-center"
                        >
                           {{table.pagination.currentPage == 1 ? ( index + 1 ) : (((table.pagination.currentPage-1)*table.pagination.pageSize)+(index + 1))}}
                        </td>
                        <td class="text-center">{{item.code || '-'}}</td>
                        <td >{{item.data.indicator.name || '-'}}</td>
                        <td >{{item.data.indicator.definition || '-'}}</td>
                        <td class="text-left">
                          <span v-for="item in item.data.indicator.disaggregations" v-bind:key="item.id">
                           {{ item.name+"; &nbsp;" }}<br/></span>
                        </td>
                        <td>-</td>
                        <td >{{item.data.indicator.measurement ? item.data.indicator.measurement.name : '-'}}</td>
                        <td >{{item.data.indicator.measurement_unit ? item.data.indicator.measurement_unit.name : '-'}}</td>
                        <td class="text-left">
                           <span v-for="item in item.data.indicator.concepts" v-bind:key="item.id">
                           {{ item.name+"; &nbsp;" }}<br/></span>
                        </td>
                        <td>
                           <span  style="background:none;border:none;border-radius:0" :class="'text-left p-0 status status--'+statusFormatterStyle(item.status)">
                              {{statusFormatter(item.status)}}
                           </span>
                           <span v-if="isRejected(item.status)"> 
                              : {{rejectionNoteFormatter(item.status.rejection_note)}} </span>
                        </td> 
                        
                     </tr>
                     <tr  v-if="isRejected(item.status) && item.alternative_sds_item">
                        <td colspan="9" class="text-bold">Rekomendasi usulan pengganti :</td>
                     </tr>
                     <tr  v-for="i in item.alternative_sds_item != null ?  itemRows(item.alternative_sds_item.data.indicator.concepts, item.alternative_sds_item.data.indicator.disaggregations) : 0"  :key="i" >
                        <td v-if="i==1" :rowspan="itemRows(item.alternative_sds_item.data.indicator.concepts, item.alternative_sds_item.data.indicator.disaggregations)" class="text-center">
                           {{item.alternative_sds_item.data.indicator.code || '-'}}
                        </td>
                        <td v-if="i==1" :rowspan="itemRows(item.alternative_sds_item.data.indicator.concepts, item.alternative_sds_item.data.indicator.disaggregations)">
                           {{item.alternative_sds_item.data.indicator.name || '-'}}
                        </td>
                        <td v-if="i==1" :rowspan="itemRows(item.alternative_sds_item.data.indicator.concepts, item.alternative_sds_item.data.indicator.disaggregations)">
                           {{item.alternative_sds_item.data.indicator.definition || '-'}}
                        </td>
                        <td class="text-left" :style="getArrayValueByIndexAndKey(item.alternative_sds_item.data.indicator.concepts, i-1,'name') ? '':'border-top:none'">
                           {{ getArrayValueByIndexAndKey(item.alternative_sds_item.data.indicator.concepts, i-1,'name')}}
                        </td>
                        <td class="text-left" :style="getArrayValueByIndexAndKey(item.alternative_sds_item.data.indicator.disaggregations, i-1,'name') ? '':'border-top:none'">
                           {{ getArrayValueByIndexAndKey(item.alternative_sds_item.data.indicator.disaggregations, i-1,'name')}}
                        </td>
                        <td v-if="i==1" :rowspan="itemRows(item.alternative_sds_item.data.indicator.concepts, item.alternative_sds_item.data.indicator.disaggregations)">
                           {{item.alternative_sds_item.data.indicator.measurement ? item.alternative_sds_item.data.indicator.measurement.name : '-'}}
                        </td>
                        <td v-if="i==1" :rowspan="itemRows(item.alternative_sds_item.data.indicator.concepts, item.alternative_sds_item.data.indicator.disaggregations)">
                           {{item.alternative_sds_item.data.indicator.measurement_unit ? item.alternative_sds_item.data.indicator.measurement_unit.name : '-'}}
                        </td>
                        <td v-if="i==1" :rowspan="itemRows(item.alternative_sds_item.data.indicator.concepts, item.alternative_sds_item.data.indicator.disaggregations)">
                           <span  style="background:none;border:none;border-radius:0" :class="'text-left p-0 status status--'+statusFormatterStyle(item.alternative_sds_item.status)">
                              {{statusFormatter(item.alternative_sds_item.status)}}
                           </span>
                        </td> 
                     </tr>

                     <!-- <tr v-if="!item.data.indicator.disaggregations || item.data.indicator.disaggregations.filter(x=>x!=null).length==0">
                        <td class="text-center">{{table.pagination.currentPage == 1 ? ( index + 1 ) : (((table.pagination.currentPage-1)*table.pagination.pageSize)+(index + 1))}}</td>
                        <td class="text-center">{{item.data.indicator && item.data.indicator.code ? item.data.indicator.code : '-'}}</td>
                        <td>{{item.data.indicator && item.data.indicator.name ? item.data.indicator.name : '-'}}</td>
                        <td>{{item.data.indicator && item.data.indicator.definition ? item.data.indicator.definition : '-'}}</td>
                        <td>{{item.data.indicator && item.data.indicator.definition ? item.data.indicator.definition : '-'}}</td>
                        <td class="text-center">-</td>
                        <td class="text-center">{{item.data.indicator && item.data.indicator.measurement ? item.data.indicator.measurement.name : '-'}}</td>
                        <td class="text-center">{{item.data.indicator && item.data.indicator.measurement_unit ? item.data.indicator.measurement_unit.name : '-'}}</td>
                        <td class="text-left">
                           <span  style="background:none;border:none;border-radius:0" :class="'text-left p-0 status status--'+statusFormatterStyle(item.status)">
                              {{statusFormatter(item.status)}}
                           </span>
                           <span v-if="isRejected(item.status)"> 
                              : {{rejectionNoteFormatter(item.rejection_note)}} </span>
                        </td>
                     </tr>

                     <tr v-for="(val_dom,index2) in item.data.indicator.disaggregations.filter(x=>x!=null)" :key="index2">
                        <td v-if="index2==0" :rowspan="item.data.indicator.disaggregations.length" class="text-center">{{table.pagination.currentPage == 1 ? ( index + 1 ) : (((table.pagination.currentPage-1)*table.pagination.pageSize)+(index + 1))}}</td>
                       
                        <td v-if="index2==0" :rowspan="item.data.indicator.disaggregations.length" class="text-center">{{item.data.indicator && item.data.indicator.code ? item.data.indicator.code : '-'}}</td>
                        <td v-if="index2==0" :rowspan="item.data.indicator.disaggregations.length">{{item.data.indicator && item.data.indicator.name ? item.data.indicator.name : '-'}}</td>
                        <td v-if="index2==0" :rowspan="item.data.indicator.disaggregations.length">{{item.data.indicator && item.data.indicator.definition ? item.data.indicator.definition : '-'}}</td>
                        <td style="padding-left:6px !important;">{{val_dom.name}}</td>
                        <td v-if="index2==0" :rowspan="item.data.indicator.disaggregations.length" class="text-center">{{item.data.indicator && item.data.indicator.measurement ? item.data.indicator.measurement.name : '-'}}</td>
                        <td v-if="index2==0" :rowspan="item.data.indicator.disaggregations.length" class="text-center">{{item.data.indicator && item.data.indicator.measurement_unit ? item.data.indicator.measurement_unit.name : '-'}}</td>
                        <td v-if="index2==0" :rowspan="item.data.indicator.disaggregations.length" class="text-left">
                           <span  style="background:none;border:none;border-radius:0" :class="'text-left p-0  status status--'+statusFormatterStyle(item.status)">
                              {{statusFormatter(item.status)}}
                           </span>
                           <span v-if="isRejected(item.status)"> 
                              : {{rejectionNoteFormatter(item.rejection_note)}} </span>
                        </td>
                     </tr> -->
                     
                  </tbody>
                  <tbody v-if="table.isLoading || table.items.length==0">
                     <tr>
                        <td colspan="9">
                           <div class="table__empty">
                              <div v-if="table.isLoading">
                                 <VueFeather type="loader" animation="spin" size="18"></VueFeather> &nbsp; Memuat data dari server ({{exportPercentage}}%)</div>
                              <div v-else>
                                 <VueFeather type="alert-circle" size="18"></VueFeather> &nbsp;
                                    Data tidak tersedia, silahkan generate report terlebih dahulu
                              </div>
                           </div>
                        </td>
                     </tr>
                  </tbody>
               </table>
            </div>
         </div>
         
         
         
      </div>

      <b-modal hide-header hide-footer size="sm" id="modal-export"  content-class="text-center px-2 py-3" centered dialog-class="d-flex justify-content-center">
         <div>
            <div class="text-center py-3">
               <img src="@/assets/img/loader.gif" width="100" height="100" />
               <div style="font-weight:600;font-size:16px;color:#01ad85">
                  {{exportPercentage}} %
               </div>
               <div style="font-weight:600;font-size:16px;color:#01ad85">
                  Mohon tunggu sebentar 
               </div>
               <div style="font-weight:500;font-size:13px;color:#0a4e5c;">
                  {{exportState}}
               </div>
            </div>
         </div>
      </b-modal>
    </div>
  </div>
</template>

<script>

import "@/assets/scss/main.scss";
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import Treeselect from '@riophae/vue-treeselect'
import store from "@/store";
import sdsService from "@/services/SdsService";
// import SettingService from "@/services/SettingService";
import SdiOrganizationService from "@/services/SdiOrganizationService";
import VueFeather from 'vue-feather';
import XLSX from "xlsx";
import moment from "moment";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import * as role from '@/views/ms/SdiRole.js'

export default {
   components:{
      Treeselect,
      VueFeather
   },
   data(){
      return{
         currentExportPage:0,
         totalExportPage:0,
         exportState: 'Menarik data dari Server sedang berlangsung...',
         exportItems:[],
         submissionPeriod:null,
         sdsType:'CONCEPT',
         status:null,
         produsenDataId:null,
         walidataPusatId:null,
         fileType:'PDF',
         user:null,
         userRoles:[],
         items:[],
         filterProdusenDataVisible:true,
         filterProdusenDataDisabled:false,
         filterWalidataVisible:false,
         filterWalidataDisabled:false,
         generatedItems:null,
         conceptReferenceIds:[],
         disaggregationReferenceIds:[],
         conceptReferences:[],
         disaggregationReferences:[],
         currentFetchPage:0,
         totalFetchPage:0,
         table:{
            isLoading:false,
            items: [],
            conceptFields:[
               {
                  label:'No. Urut',
                  key:'no',
                  class:'text-center w-50'
               },
               {
                  key:'idSdsn',
                  label: 'ID SDSN',
                  class:'text-center'
               },
               {
                  key:'name',
                  label: 'Nama',
                  class:'text-left w-200'
               },
               {
                  key: 'definition',
                  label: 'Definisi',
                  class:'text-left'
               },
               {
                  key: 'status',
                  label: 'Status',
                  class:'text-center'
               },
            ],
            variableFields:[
               {
                  label:'No. Urut',
                  key:'no',
                  class:'text-center w-50'
               },
               {
                  key:'idSdsn',
                  label: 'ID SDSN',
                  class:'text-left'
               },
               {
                  key:'name',
                  label: 'Nama',
                  class:'text-left'
               },
               {
                  key: 'definition',
                  label: 'Definisi',
                  class:'text-left'
               },
               {
                  key: 'classification',
                  label: 'Klasifikasi',
                  class:'text-left'
               },
               {
                  key: 'measurement',
                  label: 'Ukuran',
                  class:'text-left'
               },
               {
                  key: 'measurement_unit',
                  label: 'Satuan',
                  class:'text-left'
               },
            ],
            indicatorFields:[
               {
                  label:'No. Urut',
                  key:'no',
                  class:'text-center w-50'
               },
               {
                  key:'idSdsn',
                  label: 'ID SDSN',
                  class:'text-left'
               },
               {
                  key:'name',
                  label: 'Nama',
                  class:'text-left'
               },
               {
                  key: 'definition',
                  label: 'Definisi',
                  class:'text-left'
               },
               {
                  key: 'classification',
                  label: 'Klasifikasi',
                  class:'text-left'
               },
               {
                  key: 'measurement',
                  label: 'Ukuran',
                  class:'text-left'
               },
               {
                  key: 'measurement',
                  label: 'Satuan',
                  class:'text-left'
               },
            ],
            pagination:{
               currentPage:1,
               pageSize: 10,
               totalPages: 0,
               totalElements:0,
               goto:null
            },
         },
         options:{
            submissionPeriod:[],
            submissionType:[
               {value:'NEW', text:'Baru'},
               {value:'UPDATE', text:'Pemutakhiran'},
            ],
            sdsType:[
               {id:'CONCEPT', label:'Konsep & Definisi'},
               {id:'VARIABLE', label:'Variabel'},
               {id:'INDICATOR', label:'Indikator'},
            ],
            fileType:[
               {id:'PDF', label:'PDF'},
               {id:'EXCEL', label:'Excel'},
            ],
            kabkotaStatus:[
               {value:'DRAFT_KABKOTA', label:'Draft Produsen Data Kabupaten/Kota'},
               {value:'SUBMITTED_KABKOTA', label:'Submit Produsen Data Kabupaten/Kota'},
               {value:'REVIEW_KABKOTA', label:'Diperiksa Walidata Kabupaten/Kota'},
               {value:'CORRECTION_KABKOTA', label:'Perbaikan Produsen Data & Walidata Kabupaten/Kota'},
               {value:'PENDING_KABKOTA', label:'Ditunda Walidata Kabupaten/Kota'},
               {value:'REJECTED_KABKOTA', label:'Ditolak Walidata Kabupaten/Kota'},
               {value:'APPROVED_KABKOTA', label:'Diterima Walidata Kabupaten/Kota'},
            ],
            provinsiStatus:[
               {value:'DRAFT_PROVINSI', label:'Draft Produsen Data Provinsi'},
               {value:'SUBMITTED_PROVINSI', label:'Submit Produsen Data Provinsi'},
               {value:'REVIEW_PROVINSI', label:'Diperiksa Walidata Provinsi'},
               {value:'CORRECTION_PROVINSI', label:'Perbaikan Produsen Data & Walidata Provinsi'},
               {value:'REJECTED_PROVINSI', label:'Ditolak Walidata Provinsi'},
               {value:'APPROVED_PROVINSI', label:'Diterima Walidata Provinsi'},
               {value:'PENDING_PROVINSI', label:'Ditunda Walidata Provinsi'},

            ],
            pusatstatus:[
               {value:'DRAFT_PUSAT', label:'Draft Produsen Data Pusat'},
               {value:'SUBMITTED_PUSAT', label:'Submit Produsen Data Pusat'},
               {value:'REVIEW_PUSAT', label:'Diperiksa Walidata Pusat'},
               {value:'CORRECTION_PUSAT', label:'Perbaikan Produsen Data & Walidata Pusat'},
               {value:'REJECTED_PUSAT', label:'Ditolak Walidata Pusat'},
               {value:'APPROVED_PUSAT', label:'Diterima Walidata Pusat'},
               {value:'PENDING_PUSAT', label:'Ditunda Walidata Pusat'},
            ],
            pembinaDataPusatstatus:[
               {value:'DRAFT_PUSAT', label:'Draft Produsen Data Pusat'},
               {value:'SUBMITTED_PUSAT', label:'Submit Produsen Data Pusat'},
               {value:'REVIEW_PUSAT', label:'Diperiksa Walidata Pusat'},
               {value:'CORRECTION_PUSAT', label:'Perbaikan Produsen Data & Walidata Pusat'},
               {value:'REJECTED_PUSAT', label:'Ditolak Walidata Pusat'},
               {value:'APPROVED_PUSAT', label:'Diterima Walidata Pusat'},
               {value:'PENDING_PUSAT', label:'Ditunda Walidata Pusat'},
               {value:'PUBLISHED_PUSAT', label:'Publish'},
            ],
            status:[
               {value:'DRAFT_KABKOTA', label:'Draft Produsen Data Kabupaten/Kota'},
               {value:'SUBMITTED_KABKOTA', label:'Submit Produsen Data Kabupaten/Kota'},
               {value:'REVISED_KABKOTA', label:'Sudah diperbaiki Produsen Data Kabupaten/Kota'},
               {value:'REVIEW_KABKOTA', label:'Diperiksa Walidata Kabupaten/Kota'},
               {value:'CORRECTION_KABKOTA', label:'Perlu Perbaikan Produsen Data & Walidata Kabupaten/Kota'},
               {value:'PENDING_KABKOTA', label:'Ditunda Walidata Kabupaten/Kota'},
               {value:'REJECTED_KABKOTA', label:'Ditolak Walidata Kabupaten/Kota'},
               {value:'APPROVED_KABKOTA', label:'Diterima Walidata Kabupaten/Kota'},

               {value:'DRAFT_PROVINSI', label:'Draft Produsen Data Provinsi'},
               {value:'SUBMITTED_PROVINSI', label:'Submit Produsen Data Provinsi'},
               {value:'REVISED_PROVINSI', label:'Sudah diperbaiki Produsen Data Provinsi'},
               {value:'REVIEW_PROVINSI', label:'Diperiksa Walidata Provinsi'},
               {value:'CORRECTION_PROVINSI', label:'Perbaikan Produsen Data & Walidata Provinsi'},
               {value:'REJECTED_PROVINSI', label:'Ditolak Walidata Provinsi'},
               {value:'APPROVED_PROVINSI', label:'Diterima Walidata Provinsi'},
               {value:'PENDING_PROVINSI', label:'Ditunda Walidata Provinsi'},

               {value:'DRAFT_PUSAT', label:'Draft Produsen Data Pusat'},
               {value:'SUBMITTED_PUSAT', label:'Submit Produsen Data Pusat'},
               {value:'REVISED_PUSAT', label:'Sudah diperbaiki Produsen Data Pusat'},
               {value:'REVIEW_PUSAT', label:'Diperiksa Walidata Pusat'},
               {value:'CORRECTION_PUSAT', label:'Perbaikan Produsen Data & Walidata Pusat'},
               {value:'REJECTED_PUSAT', label:'Ditolak Walidata Pusat'},
               {value:'APPROVED_PUSAT', label:'Diterima Walidata Pusat'},
               {value:'PENDING_PUSAT', label:'Ditunda Walidata Pusat'},
               {value:'PUBLISHED_PUSAT', label:'Publish'},
            ],
            subjectField : [],
            requester:[],
            organization:[],
            produsenData:null,
            walidata:null,
         },
      }
   },
   computed:{
      
      exportPercentage(){
        return this.currentExportPage == 0 ? 0 : (this.currentExportPage/this.totalExportPage*100).toFixed(0)
      },
      sdsStatus(){
         if(role.isProdusenDataKabupatenKota([this.appData.current_role]) ||
            role.isWalidataKabupatenKota([this.appData.current_role]) ||
            role.isPembinaDataKabupatenKota([this.appData.current_role])){
            return this.options.kabkotaStatus;
         }
         else if(role.isProdusenDataProvinsi([this.appData.current_role]) ||
            role.isWalidataProvinsi([this.appData.current_role]) ||
            role.isPembinaDataProvinsi([this.appData.current_role])){
            return this.options.provinsiStatus;
         }
         else if(role.isProdusenDataPusat([this.appData.current_role]) || role.isWalidataPusat([this.appData.current_role])){
            return this.options.pusatstatus;
         }else{
            return this.options.pembinaDataPusatstatus;
         }
      },
      isApproved(){
         let status = this.form ? this.form.status : null;
         return ['APPROVED_KABKOTA','APPROVED_PROVINSI','APPROVED_PUSAT'].includes(status) ? true : false;
      },
      isApprovedKabupatenKota(){
         let status = this.form ? this.form.status : null;
         return status == 'APPROVED_KABKOTA' ? true : false;
      },
      isApprovedProvinsi(){
         let status = this.form ? this.form.status : null;
         return status == 'APPROVED_PROVINSI' ? true : false;
      },
      isApprovedPusat(){
         let status = this.form ? this.form.status : null;
         return status == 'APPROVED_PUSAT' ? true : false;
      },
   },
   inject: ['appData'],
   async mounted(){
      this.getUserInfo(store.getters["auth/user"]);
      this.setSubmissionPeriod();
      this.resetFilter();
   },
   watch:{
      'appData.current_role'(){
         this.resetFilter();
      },
   },
   methods:{
      setSubmissionPeriod(){
         let currentYear = new Date().getFullYear();
         this.submissionPeriod = currentYear;
         this.options.submissionPeriod = this.generateYearList(2021, currentYear).reverse().map(x=>({id: parseInt(x), label:x}));
      },
      generateYearList(start, stop, step = 1){
         return Array.from({ length: (stop - start) / step + 1}, (_, i) => start + (i * step));
      },
      resetFilter(){
         if(role.isProdusenData([this.appData.current_role])){
            this.produsenDataId = this.user.organization.id;
            this.options.produsenData = [{id:this.user.organization.id, name:this.user.organization.name}]
            
            this.filterProdusenDataVisible = true;
            this.filterProdusenDataDisabled = true;

         }
         else{
            this.filterProdusenDataVisible = true;
            this.filterProdusenDataDisabled = false;
         }

         if(role.isPembinaDataPusat([this.appData.current_role])){
            this.filterWalidataVisible = true;
         }else{
            this.filterWalidataVisible = false;
         }
      },
      getUserInfo(user){
         this.user = {
            name : user.name,
            username: user.username,
            email: user.email,
            division: null,
            organization: {
               id: user.sdiOrganization.id,
               name: user.sdiOrganization.name,
               address: user.sdiOrganization.details.address,
               province: user.sdiOrganization.details.province,
               city: user.sdiOrganization.details.city,
            } 
         },
         this.userRoles = user.role.slice(1,-1).split(", ");
      },
      async produsenDataLoadOptions({searchQuery, callback}){
         let name = searchQuery;
         let page = 0;
         let provinceCode = null;
         let cityCode = null;
         let roles = [];

         if(role.isProdusenData([this.appData.current_role]) || role.isWalidata([this.appData.current_role]) || role.isPembinaDataKabupatenKota([this.appData.current_role])){
            provinceCode = this.user.organization.province.code;
            cityCode = this.user.organization.city.code;
         }
         else if(role.isPembinaDataProvinsi([this.appData.current_role])){
            provinceCode = this.user.organization.province.code;
         }

         if(!role.isProdusenData([this.appData.current_role])){
            roles = ['PRODUSEN_DATA','WALIDATA']
         }

         await SdiOrganizationService.getAllSdiOrganization(page, name, provinceCode, cityCode, roles).then(
            (result)=>{
               let options = result.data.content;
               callback(null, options)
            },
            (error)=>{
               console.log(error)
            }
         );
      },
      async walidataPusatLoadOptions({searchQuery, callback}){
         let name = searchQuery;
         let page = 0;
         let provinceCode = '00';
         let cityCode = '0000';
         let roles = ['WALIDATA'];
         await SdiOrganizationService.getAllSdiOrganization(page, name, provinceCode, cityCode, roles).then(
            (result)=>{
               let options = result.data.content;
               callback(null, options)
            },
            (error)=>{
               console.log(error)
            }
         );
      },
      normalizer(node) {
         return {
            id: node.value,
            label: node.label,
            children: node.children,
         }
      },
      produsenDataNormalizer(node) {
         return {
            id: node.id,
            label: node.name,
         }
      },
      async getSdsItemDetail(id){
         let sdsItem = null;
         await sdsService.getSdsItem(id).then(
            (result)=>{
               sdsItem = {...result.data.result[0]};
               // console.log(result);
            },
            (error)=>{
               console.log(error);
            }
         );
         
         return sdsItem;
      },
      async getSdsItemList(){
         this.conceptReferenceIds=[];
         this.disaggregationReferenceIds=[];
         this.totalExportPage = 0;
         this.currentExportPage = 0;
         this.table.items = [];
         this.table.isLoading = true;
         let sdsType = this.sdsType;
         let submissionPeriod = this.submissionPeriod;
         let status = this.status;
         let produsenDataId = this.produsenDataId;
         let walidataPusatId = this.walidataPusatId;
         let page = 0;

         let query ="submissionPeriod="+submissionPeriod+"&page="+page+"&size=100";
         
         
         if(sdsType){
            query += "&sdsType="+sdsType;
         }
         if(status){
            query += "&status="+status;
         }
         if(produsenDataId){
               query += "&produsenDataId="+produsenDataId;
         }
         if(walidataPusatId){
            query += "&walidataPusatId="+walidataPusatId;
         }
         await sdsService.getSdsItemReportByQuery(query).then(
            async (result)=>{
               let response = result.data.result[0];
               this.generatedItems = response.content;
               this.table.pagination.totalPages = response.total_pages;
               this.table.pagination.totalElements= response.total_elements;
               this.totalExportPage = response.total_pages;
               this.currentExportPage = page + 1;
               

               if(this.table.pagination.totalPages>1){
                  await this.getRemainingSdsItem();
               }
               for(const item of this.table.items){
                  if(this.isRejected(item.status) && item.alternative_sds_item_id){
                     item.alternative_sds_item = await this.getSdsItemDetail(item.alternative_sds_item_id);
                  }
               }
               //sync concept
               this.table.items = this.generatedItems;
               if(sdsType != 'CONCEPT'){
                  this.conceptReferenceIds =[...this.conceptReferenceIds , ...this.table.items.map(x=>{
                     let ids = sdsType == 'VARIABLE' ? x.data.variable.concepts.map(x=>x.id) : x.data.indicator.concepts.map(x=>x.id);
                     return ids;
                  })]
                  this.conceptReferenceIds = [...new Set(this.conceptReferenceIds.flat())];
                  await this.getSdsItemReferenceList(this.conceptReferenceIds, 'concept')
               }
               
               if(sdsType == 'INDICATOR'){
                  this.disaggregationReferenceIds =[...this.disaggregationReferenceIds , ...this.table.items.map(x=>{
                     let ids = x.data.indicator.disaggregations.map(x=>x.id);
                     return ids;
                  })]
                  this.disaggregationReferenceIds = [...new Set(this.disaggregationReferenceIds.flat())];
                  await this.getSdsItemReferenceList(this.disaggregationReferenceIds, 'disaggregations')
               }
               
               this.table.isLoading = false;

               
            },
            (error)=>{
               console.log(error)
            }
         )
        
         
      },
      async getRemainingSdsItem(){
         let sdsType = this.sdsType;
         let submissionPeriod = this.submissionPeriod;
         let status = this.status;
         let produsenDataId = this.produsenDataId;
         let walidataPusatId = this.walidataPusatId;

         let query ="submissionPeriod="+submissionPeriod+"&size=100";
         if(sdsType){
            query += "&sdsType="+sdsType;
         }
         if(status){
            query += "&status="+status;
         }
         if(produsenDataId){
            query += "&produsenDataId="+produsenDataId;
         }
         if(walidataPusatId){
            query += "&walidataPusatId="+walidataPusatId;
         }
         for (let i = 1; i < this.totalExportPage; i++) {
            let newQuery = query + "&page="+i;
            await sdsService.getSdsItemReportByQuery(newQuery).then(
               async (result)=>{
                  let newItems = result.data.result[0].content;
                  this.currentExportPage = i+1
                  this.generatedItems = [...this.generatedItems,...newItems];
               },
               (error)=>{
                  console.log(error)
               }
            )
         }
      },
      async getSdsItemReferenceList(ids, type){
         this.totalFetchPage = 0;
         let page = 0;
         let sdsType = type == 'concept' ? 'CONCEPT' : 'VARIABLE';
         let submissionPeriod = this.submissionPeriod;
         let query ="submissionPeriod="+submissionPeriod+"&page="+page+"&size=50"+"&id="+ids;
         if(sdsType){
            query += "&sdsType="+sdsType;
         }
         await sdsService.getSdsItemListByQuery(query).then(
            async (result)=>{
               console.log(result)
               this.totalFetchPage = result.data.total_pages;
               let items = result.data.content;
               if(sdsType == 'CONCEPT'){
                  this.conceptReferences = items;
               }else{
                  this.disaggregationReferences = items;
               }
               if(this.totalFetchPage>1){
                  await this.getRemainingSdsItemReferenceList(ids, sdsType);
               }
            },
            (error)=>{
               console.log(error)
            }
         )
      },
      async getRemainingSdsItemReferenceList(ids, sdsType ){
         let submissionPeriod = this.submissionPeriod;
         let query ="submissionPeriod="+submissionPeriod+"&size=50"+"&id="+ids+"&sdsType="+sdsType;
         for (let i = 1; i < this.totalFetchPage; i++) {
            let newQuery = query + "&page="+i;
            await sdsService.getSdsItemListByQuery(newQuery).then(
               async (result)=>{

                  let newItems = result.data.content;
                  if(sdsType == 'CONCEPT'){
                     this.conceptReferences = [...this.conceptReferences,...newItems];
                  }else{
                     this.disaggregationReferences = [...this.disaggregationReferences,...newItems];
                  }
               },
               (error)=>{
                  console.log(error)
               }
            )
         }
         
      },
      async exportReport(){
         
         
         if(this.fileType == 'EXCEL'){
            this.downloadExcel() 
         }else{
            this.downloadPdf() 
         }
         
      },
      downloadExcel() {
         
         /* make worksheet from json */
         const worksheet = this.sdsType == 'CONCEPT' ?  "Konsep dan Definisi" :(this.sdsType == 'VARIABLE' ? 'Variabel':'Indikator');
         var workbook = XLSX.utils.book_new();

         /* convert table "export-kegiatan" to worksheet named "worksheetMsKeg" */
         var data = null;
         if(this.sdsType == 'CONCEPT'){
            data = document.getElementById("export-concepts");
         }else if(this.sdsType == 'VARIABLE'){
            data = document.getElementById("export-variables");
         }else{
            data = document.getElementById("export-indicators");
         }

         var worksheetData = XLSX.utils.table_to_sheet(data);
         /* Add the worksheet to the workbook */
         XLSX.utils.book_append_sheet(workbook,worksheetData,worksheet);
         /*create file*/
         let createdDate = moment(new Date()).format("DD_MM_YYYY");
         let fileName = this.sdsType == 'CONCEPT' ? "export_konsep_" : (this.sdsType == 'VARIABLE' ? "export_variabel_" : "export_indikator_") ;
         fileName = fileName + createdDate + ".xlsx";
         XLSX.writeFile(workbook, fileName , { bookSST: false, type: "application/vnd.ms-excel", bookType: "xlsx"});
         
      },
      downloadPdf(){
         let body = [];
         let column = [];
         if(this.sdsType == 'CONCEPT'){
            column = [
               {
                  text: "No",
                  style: "tableHeader",
                  alignment: "center",
                  fillColor: "#EEEEEE"
               },
               {
                  text: "ID SDSN",
                  style: "tableHeader",
                  alignment: "center",
                  fillColor: "#EEEEEE"
               },
               {
                  text: "Konsep",
                  style: "tableHeader",
                  alignment: "center",
                  fillColor: "#EEEEEE"
               },
               {
                  text: "Definisi",
                  style: "tableHeader",
                  alignment: "center",
                  fillColor: "#EEEEEE"
               },
               {
                  text: "Status",
                  style: "tableHeader",
                  alignment: "center",
                  fillColor: "#EEEEEE"
               },
            ];
         }else{
            column = [
               {
                  text: "No",
                  style: "tableHeader",
                  alignment: "center",
                  fillColor: "#EEEEEE"
               },
               {
                  text: "ID SDSN",
                  style: "tableHeader",
                  alignment: "center",
                  fillColor: "#EEEEEE"
               },
               {
                  text: "Konsep",
                  style: "tableHeader",
                  alignment: "center",
                  fillColor: "#EEEEEE"
               },
               {
                  text: "Definisi",
                  style: "tableHeader",
                  alignment: "center",
                  fillColor: "#EEEEEE"
               },
               {
                  text: "Klasifikasi",
                  style: "tableHeader",
                  alignment: "center",
                  fillColor: "#EEEEEE"
               },
               {
                  text: "Satuan",
                  style: "tableHeader",
                  alignment: "center",
                  fillColor: "#EEEEEE"
               },
               {
                  text: "Ukuran",
                  style: "tableHeader",
                  alignment: "center",
                  fillColor: "#EEEEEE"
               },
               {
                  text: "Status",
                  style: "tableHeader",
                  alignment: "center",
                  fillColor: "#EEEEEE"
               },
            ];
         }
         body.push(column);
         if(this.sdsType == 'CONCEPT'){
            this.table.items.forEach((item, index) => {
               body.push([
                  { text: (index + 1).toString(), alignment: "center" },
                  // 'Konsep',
                  {text:item.data.concept.code ? item.data.concept.code : '-', alignment: "center" },
                  item.data.concept.name,
                  item.data.concept.definition,
                  {text: this.statusFormatter(item.status)+ (this.isRejected(item.status) ? '\n\n Alasan ditolak : '+ item.rejection_note.note : '') }
               ]);
            });
         }
         else if(this.sdsType == 'VARIABLE'){
            this.table.items.forEach((item, index) => {
               let Klasifikasi = [];
               let items = []
               if(item.data.variable.value_domain){
                  if(item.data.variable.value_domain.items){
                     items = item.data.variable.value_domain.items
                  }else if(item.data.variable.value_domain.classification){
                     items = item.data.variable.value_domain.classification.items
                  }else{
                     items = []
                  }
               }
               items.forEach(val_dom => {
                  Klasifikasi.push("("+val_dom.code + ") " + val_dom.name);
               });
               body.push([
                  { text: (index + 1).toString(), alignment: "center" },
                  // 'Variabel',
                  {text:item.data.variable.code ? item.data.variable.code : '-', alignment: "center" },
                  item.data.variable.name,
                  item.data.variable.definition,
                  { ul: Klasifikasi },
                  {text:item.data.variable.measurement ? item.data.variable.measurement.name : '-', alignment: "center" },
                  {text:item.data.variable.measurement_unit ? item.data.variable.measurement_unit.name : '-', alignment: "center" },
               ]);
            });
         }
         else{
            this.table.items.forEach((item, index) => {
               let Klasifikasi = [];
               let disaggregations = item.data.indicator.disaggregations;
               disaggregations.forEach(disaggregation => {
                  Klasifikasi.push(disaggregation.name);
               });
               body.push([
                  { text: (index + 1).toString(), alignment: "center" },
                  // 'Indicator',
                  {text:item.data.indicator.code ? item.data.indicator.code : '-', alignment: "center" },
                  item.data.indicator.name,
                  item.data.indicator.definition,
                  { ul: Klasifikasi },
                  {text:item.data.indicator.measurement ? item.data.indicator.measurement.name : '-', alignment: "center" },
                  {text:item.data.indicator.measurement_unit ? item.data.indicator.measurement_unit.name : '-', alignment: "center" },
               ]);
            });
         }
         
         let docDefinition = {
            pageSize: "LEGAL",
            pageOrientation: "landscape",
            pageMargins: [20, 30, 20, 30],
            content: [
               {
                  text: this.sdsType == 'CONCEPT' ? "KONSEP DAN DEFINISI BAKU STATISTIK (KONDEF)" : (this.sdsType == 'VARIABLE' ? 'VARIABEL' : 'INDIKATOR'),
                  alignment: "center",
                  style: "header"
               },
               {
                  style: "tableExample",
                  table: {
                     headerRows: 1,
                     widths: this.sdsType == 'CONCEPT' ? [30, 40, "*", "*","*"] : [30, 40, "*", "*", 100, 80, 80, "*"],
                     body: body
                  }
               }
            ],
            styles: {
               header: {
                  fontSize: 18,
                  bold: true,
                  margin: [0, 0, 0, 10]
               },
               subheader: {
                  fontSize: 16,
                  bold: true,
                  margin: [0, 10, 0, 5]
               },
               tableExample: {
                  margin: [0, 5, 0, 15],
                  fontSize: 9,
                  color: "black",
                  bold: false
               },
               tableHeader: {
                  bold: false,
                  fontSize: 9,
                  color: "black"
               }
            },
            defaultStyle: {}
         };
         pdfMake.vfs = pdfFonts.pdfMake.vfs;
         var pdf = pdfMake.createPdf(docDefinition);

         const createdDate = moment(new Date()).format("DD_MM_YYYY");
         const fileName = this.sdsType == 'CONCEPT' ? "export_konsep_" : (this.sdsType == 'VARIABLE' ? "export_variabel_" : "export_indikator_") + createdDate + ".pdf";
         pdf.download(fileName);
      },
      rejectionNoteFormatter(note){
         if(note){
            if(note.type == 'SIMILAR_SDSN_ALREADY_EXISTS'){
               return 'Sudah ada di SDSN'
            }
            else if(note.type == 'SIMILAR_REQUEST_ALREADY_EXISTS'){
               return 'Sudah ada usulan yang mirip'
            }
            else if(note.type == 'IMPROPERLY_REQUEST'){
               return 'Usulan tidak layak'
            }else{
               return note.note
            }
         }else{
            return 'Tidak ada catatan'
         }
      },
      statusFormatter(status){
         return status ? this.options.status.find(x=>x.value == status).label : 'Draft';
      },
      statusFormatterStyle(status){
         return status ? status.split('_')[0].toLowerCase() : 'draft';
      },
      isRejected(status){
         return status && status.split('_')[0] == 'REJECTED';
      },
      itemRows(array1, array2){ 
         console.log(array1, array2)
         if((Array.isArray(array1) && array1.length) && (Array.isArray(array2) && array2.length) ) {
            return array1.length > array2.length ? array1.length : array2.length;
         }
         else if((Array.isArray(array1) && array1.length) || (Array.isArray(array2) && array2.length) ) {
            return Array.isArray(array1) && array1.length ? array1.length : array2.length;
         }
         else{
            return 1
         }
      },
      getArrayValueByIndexAndKey(array, index, key){
         if(Array.isArray(array) && array.length){
            if(array[index]){
               return array[index][key] || '-'
            }
            else{
               return ''
            }
            
         }else{
            return ''
         }
      },
      async getConceptsValueByIndex(array, index){
         //array is concepts
         //index is concepts[index]
         //key is id
         if(Array.isArray(array) && array.length && array[index] && array[index]['id'] ){
            //syncing - find current concepts
            let id = array[index]['id'];
            await sdsService.getSdsItem(id).then(
               (result)=>{
                  return result.data.result[0].name;
               },
            );

            
         }else{
            return ''
         }

        
         
         
      }
   }
}
</script>

